import Top from './top';
import Bottom from './bottom';

export default { Top, Bottom };